import { Controller } from "@hotwired/stimulus"

export default class extends Controller {

	static targets = [
		'nestedForm',
		'nestedFormDestroyButton',
		'nestedFormTemplate',
		'nestedFormContainer',
	]

	static values = {
		nestedFormSelector: { type: String, default: '.nested-form' },
		nestedFormIdSelector: { type: String, default: '.nested-form-id' },
		nestedFormDestroySelector: { type: String, default: '.nested-form-destroy' },
		required: { type: Boolean, default: true },
	}

	nestedFormTargetConnected(_element)    { this.updateDestroyButton() }
	nestedFormTargetDisconnected(_element) { this.updateDestroyButton() }

	add(_event) {
		const templateContent = this.nestedFormTemplateTarget.content.cloneNode(true)
		this.nestedFormContainerTarget.appendChild(templateContent)
	}

	updateDestroyButton() {
		if (!this.requiredValue && this.hasNestedFormDestroyButtonTarget) {
			this.nestedFormDestroyButtonTargets.forEach( (element) => element.classList.remove('d-none') )
			return
		}

		const activeNestedForms = this.nestedFormTargets.filter( (nestedForm) => !nestedForm.classList.contains('d-none') )
		if (activeNestedForms.length == 0) { return }
		if (activeNestedForms.length == 1) { this.nestedFormDestroyButtonTargets.forEach( (element) => element.classList.add('d-none') ) }
		if (activeNestedForms.length  > 1) { this.nestedFormDestroyButtonTargets.forEach( (element) => element.classList.remove('d-none') ) }
	}

	destroy(event) {
		const nestedFormElement = event.currentTarget.closest(this.nestedFormSelectorValue)
		const modelId = nestedFormElement.querySelector(this.nestedFormIdSelectorValue).value

		if (modelId && modelId.length > 0) {
			nestedFormElement.classList.add('d-none')

			nestedFormElement
				.querySelectorAll(this.nestedFormDestroySelectorValue)
				.forEach( (destroyInput) => destroyInput.value = '1' )

		} else {
			nestedFormElement.remove()
		}

		/*
		} else if(this.hasInputDisableDestroyCheckboxTarget) {
			for (const checkbox of this.inputDisableDestroyCheckboxTargets) { checkbox.checked = false }
			this.hideElement()
		*/

		this.updateDestroyButton()

		this.dispatch("destroy")
	}
}
